import gql from "graphql-tag";
import { getFieldsFromSchema } from "../services";
import { userSchema } from "shared";

export const USER_FULL_FRAGMENT = gql`
  fragment UserFullFragment on User {
    ${getFieldsFromSchema(userSchema)}
  }
`;
